var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_363_6213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.69134 0.199395C1.94124 0.927644 0 3.15887 0 5.56054C0 7.26496 0.692165 8.94533 2.3584 10.0455C3.24814 10.6343 5.209 11.1386 6.26051 11.1386H7.11789V12.0684C7.11789 12.5332 7.11789 13.0357 7.11789 12.998C7.44143 12.9979 9.20141 11.9938 10.3533 11.1385C12.493 9.5498 13.4925 7.0498 12.7637 4.30548C12.246 2.75601 11.0004 1.31501 9.60915 0.679729C8.10469 -0.00203514 6.17962 -0.187971 4.69134 0.199395Z",
    fill: "#757575"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_363_6213"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.05f3896afbdbd9c912dede8ec46304c1.svg";
export { ForwardRef as ReactComponent };